'use client';

import React, { useMemo } from 'react';
import { type SearchDealsPageData } from '@/app/components/search/components/SearchPageContainer';

export const SearchDealsPageContext = React.createContext<SearchDealsPageData>({} as SearchDealsPageData);

export default function SearchDealsPageDataProvider({
  searchDealsPageData,
  children,
}: {
  searchDealsPageData: SearchDealsPageData;
  children: React.ReactNode;
}) {
  const contextValue = useMemo(() => searchDealsPageData, [searchDealsPageData]);
  return <SearchDealsPageContext.Provider value={contextValue}>{children}</SearchDealsPageContext.Provider>;
}

export const useSearchDealsPageData = () => React.useContext(SearchDealsPageContext);
